function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return generator._invoke = function (innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; }(innerFn, self, context), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == _typeof(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; this._invoke = function (method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); }; } function maybeInvokeDelegate(delegate, context) { var method = delegate.iterator[context.method]; if (undefined === method) { if (context.delegate = null, "throw" === context.method) { if (delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method)) return ContinueSentinel; context.method = "throw", context.arg = new TypeError("The iterator does not provide a 'throw' method"); } return ContinueSentinel; } var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) { if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; } return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, define(Gp, "constructor", GeneratorFunctionPrototype), define(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (object) { var keys = []; for (var key in object) { keys.push(key); } return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) { "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); } }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, catch: function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

/**
 * 多标签页
 * */
import { get } from 'lodash';
import router from '@/router';
import Setting from '@/setting.ht';
import menuSider from '@/menu/sider';
import { getAllSiderMenu, includeArray } from '@/libs/system'; // 判定是否需要缓存

var isKeepAlive = function isKeepAlive(data) {
  return get(data, 'meta.cache', false);
};

export default {
  namespaced: true,
  state: {
    // 可以在多页 tab 模式下显示的页面
    pool: [],
    // 当前显示的多页面列表
    opened: Setting.page.opened,
    // 当前页面
    current: '',
    // 当前顶级
    currentTop: '',
    // 需要缓存的页面 name
    keepAlive: []
  },
  actions: {
    /**
     * @description 从持久化数据载入分页列表
     */
    openedLoad: function openedLoad(_ref) {
      var state = _ref.state,
          commit = _ref.commit,
          dispatch = _ref.dispatch,
          rootState = _ref.rootState;
      return new Promise( /*#__PURE__*/function () {
        var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(resolve) {
          var value, valid;
          return _regeneratorRuntime().wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  _context.next = 2;
                  return dispatch('admin/db/get', {
                    dbName: 'sys',
                    path: 'page.opened',
                    defaultValue: Setting.page.opened,
                    user: true
                  }, {
                    root: true
                  });

                case 2:
                  value = _context.sent;
                  // 在处理函数中进行数据优化 过滤掉现在已经失效的页签或者已经改变了信息的页签
                  // 以 fullPath 字段为准
                  // 如果页面过多的话可能需要优化算法
                  // valid 有效列表 1, 1, 0, 1 => 有效, 有效, 失效, 有效
                  valid = []; // 处理数据

                  state.opened = value.map(function (opened) {
                    // 忽略门户首页
                    if (opened.fullPath === '/') {
                      valid.push(1);
                      return opened;
                    } // 忽略首页


                    if (opened.fullPath === '/index/memberCenter') {
                      valid.push(1);
                      return opened;
                    } // 尝试在所有的支持多标签页的页面里找到 name 匹配的页面


                    var find = state.pool.find(function (item) {
                      return item.name === opened.name;
                    }); // 2.3.0 如果 value 项有 keepMeta 字段，则保留 meta

                    if (opened.keepMeta) {
                      find.meta = Object.assign({}, opened.meta);
                    } // 记录有效或无效信息


                    valid.push(find ? 1 : 0); // 返回合并后的数据 新的覆盖旧的
                    // 新的数据中一般不会携带 params 和 query, 所以旧的参数会留存

                    return Object.assign({}, opened, find);
                  }).filter(function (opened, index) {
                    return valid[index] === 1;
                  }) // 对 menu 鉴权过滤
                  .filter(function (opened) {
                    var allSiderMenu = getAllSiderMenu(menuSider);
                    var find = allSiderMenu.find(function (item) {
                      return item.path === opened.fullPath;
                    });
                    var state = true;

                    if (find && find.auth) {
                      var userInfo = rootState.admin.user.info; // @权限

                      var access = userInfo.access; // 如果用户当前的权限，不是该 menu 对应的 权限，则过滤这个 Tab

                      if (access && !includeArray(find.auth, access)) state = false;
                    }

                    return state;
                  }); // 根据 opened 数据生成缓存设置

                  commit('keepAliveRefresh'); // end

                  resolve();

                case 7:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee);
        }));

        return function (_x) {
          return _ref2.apply(this, arguments);
        };
      }());
    },

    /**
     * 将 opened 属性赋值并持久化 在这之前请先确保已经更新了 state.opened
     */
    opened2db: function opened2db(_ref3) {
      var state = _ref3.state,
          dispatch = _ref3.dispatch;
      return new Promise( /*#__PURE__*/function () {
        var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(resolve) {
          return _regeneratorRuntime().wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  // 设置数据
                  dispatch('admin/db/set', {
                    dbName: 'sys',
                    path: 'page.opened',
                    value: state.opened,
                    user: true
                  }, {
                    root: true
                  }); // end

                  resolve();

                case 2:
                case "end":
                  return _context2.stop();
              }
            }
          }, _callee2);
        }));

        return function (_x2) {
          return _ref4.apply(this, arguments);
        };
      }());
    },

    /**
     * @description 更新页面列表上的某一项
     * @param {Object} param { index, params, query, fullPath } 路由信息
     */
    openedUpdate: function openedUpdate(_ref5, _ref6) {
      var state = _ref5.state,
          commit = _ref5.commit,
          dispatch = _ref5.dispatch;
      var index = _ref6.index,
          params = _ref6.params,
          query = _ref6.query,
          fullPath = _ref6.fullPath,
          meta = _ref6.meta,
          _ref6$keepMeta = _ref6.keepMeta,
          keepMeta = _ref6$keepMeta === void 0 ? false : _ref6$keepMeta;
      return new Promise( /*#__PURE__*/function () {
        var _ref7 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(resolve) {
          var page;
          return _regeneratorRuntime().wrap(function _callee3$(_context3) {
            while (1) {
              switch (_context3.prev = _context3.next) {
                case 0:
                  // 更新页面列表某一项
                  page = state.opened[index];
                  page.params = params || page.params;
                  page.query = query || page.query;
                  page.fullPath = fullPath || page.fullPath;
                  page.meta = meta || page.meta;
                  page.keepMeta = keepMeta;
                  state.opened.splice(index, 1, page); // 持久化

                  _context3.next = 9;
                  return dispatch('opened2db');

                case 9:
                  // end
                  resolve();

                case 10:
                case "end":
                  return _context3.stop();
              }
            }
          }, _callee3);
        }));

        return function (_x3) {
          return _ref7.apply(this, arguments);
        };
      }());
    },

    /**
     * @description 更新页面当前项
     * @param {Object} param { params, query, fullPath } 路由信息
     */
    currentUpdate: function currentUpdate(_ref8, _ref9) {
      var state = _ref8.state,
          commit = _ref8.commit,
          dispatch = _ref8.dispatch;
      var params = _ref9.params,
          query = _ref9.query,
          fullPath = _ref9.fullPath,
          meta = _ref9.meta,
          _ref9$keepMeta = _ref9.keepMeta,
          keepMeta = _ref9$keepMeta === void 0 ? false : _ref9$keepMeta;
      return new Promise( /*#__PURE__*/function () {
        var _ref10 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5(resolve) {
          return _regeneratorRuntime().wrap(function _callee5$(_context5) {
            while (1) {
              switch (_context5.prev = _context5.next) {
                case 0:
                  setTimeout( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
                    var index, page;
                    return _regeneratorRuntime().wrap(function _callee4$(_context4) {
                      while (1) {
                        switch (_context4.prev = _context4.next) {
                          case 0:
                            // 更新当前项
                            index = state.opened.findIndex(function (item) {
                              return item.fullPath === state.current;
                            });
                            page = state.opened[index];
                            page.params = params || page.params;
                            page.query = query || page.query;
                            page.fullPath = fullPath || page.fullPath;
                            page.meta = meta || page.meta;
                            page.keepMeta = keepMeta;
                            state.opened.splice(index, 1, page); // 持久化

                            _context4.next = 10;
                            return dispatch('opened2db');

                          case 10:
                            // end
                            resolve();

                          case 11:
                          case "end":
                            return _context4.stop();
                        }
                      }
                    }, _callee4);
                  })), 0);

                case 1:
                case "end":
                  return _context5.stop();
              }
            }
          }, _callee5);
        }));

        return function (_x4) {
          return _ref10.apply(this, arguments);
        };
      }());
    },

    /**
     * @description 新增一个 tag (打开一个页面)
     * @param {Object} param new tag info
     */
    add: function add(_ref12, _ref13) {
      var state = _ref12.state,
          commit = _ref12.commit,
          dispatch = _ref12.dispatch;
      var tag = _ref13.tag,
          params = _ref13.params,
          query = _ref13.query,
          fullPath = _ref13.fullPath;
      return new Promise( /*#__PURE__*/function () {
        var _ref14 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee6(resolve) {
          var newTag;
          return _regeneratorRuntime().wrap(function _callee6$(_context6) {
            while (1) {
              switch (_context6.prev = _context6.next) {
                case 0:
                  // 设置新的 tag 在新打开一个以前没打开过的页面时使用
                  newTag = tag;
                  newTag.params = params || newTag.params;
                  newTag.query = query || newTag.query;
                  newTag.fullPath = fullPath || newTag.fullPath;
                  console.log(newTag, 'newTag');

                  if (newTag.params.menuCode != 'lcpAgrOrderDetail' && newTag.params.menuCode != 'lcpEcOrderDetail') {
                    // 添加进当前显示的页面数组
                    state.opened.push(newTag);
                  } // 如果这个页面需要缓存 将其添加到缓存设置


                  if (isKeepAlive(newTag)) {
                    commit('keepAlivePush', tag.name);
                  } // 持久化


                  _context6.next = 9;
                  return dispatch('opened2db');

                case 9:
                  // end
                  resolve();

                case 10:
                case "end":
                  return _context6.stop();
              }
            }
          }, _callee6);
        }));

        return function (_x5) {
          return _ref14.apply(this, arguments);
        };
      }());
    },

    /**
     * @description 打开一个新的页面
     * @param {Object} param 从路由钩子的 to 对象上获取 { name, params, query, fullPath } 路由信息
     */
    open: function open(_ref15, _ref16) {
      var state = _ref15.state,
          commit = _ref15.commit,
          dispatch = _ref15.dispatch;
      var name = _ref16.name,
          params = _ref16.params,
          query = _ref16.query,
          fullPath = _ref16.fullPath;
      return new Promise( /*#__PURE__*/function () {
        var _ref17 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee7(resolve) {
          var opened, pageOpenedIndex, pageOpened, page;
          return _regeneratorRuntime().wrap(function _callee7$(_context7) {
            while (1) {
              switch (_context7.prev = _context7.next) {
                case 0:
                  // 已经打开的页面
                  opened = state.opened; // 判断此页面是否已经打开 并且记录位置

                  pageOpenedIndex = 0;
                  pageOpened = opened.find(function (page, index) {
                    var same = page.fullPath === fullPath;

                    if (page.name == 'iframe' && page.params.menuCode == params.menuCode) {
                      same = true;
                    } else if (page.name === name) {
                      same = true;
                    }

                    pageOpenedIndex = same ? index : pageOpenedIndex;
                    return same;
                  });

                  if (!pageOpened) {
                    _context7.next = 8;
                    break;
                  }

                  _context7.next = 6;
                  return dispatch('openedUpdate', {
                    index: pageOpenedIndex,
                    params: params,
                    query: query,
                    fullPath: fullPath
                  });

                case 6:
                  _context7.next = 12;
                  break;

                case 8:
                  // 页面以前没有打开过
                  page = state.pool.find(function (t) {
                    return t.name === name;
                  }); // 如果这里没有找到 page 代表这个路由虽然在框架内 但是不参与标签页显示

                  if (!page) {
                    _context7.next = 12;
                    break;
                  }

                  _context7.next = 12;
                  return dispatch('add', {
                    tag: Object.assign({}, page),
                    params: params,
                    query: query,
                    fullPath: fullPath
                  });

                case 12:
                  commit('currentSet', fullPath); // end

                  resolve();

                case 14:
                case "end":
                  return _context7.stop();
              }
            }
          }, _callee7);
        }));

        return function (_x6) {
          return _ref17.apply(this, arguments);
        };
      }());
    },

    /**
     * @description 关闭一个 tag (关闭一个页面)
     * @param {Object} param { tagName: 要关闭的标签名字 }
     */
    close: function close(_ref18, _ref19) {
      var state = _ref18.state,
          commit = _ref18.commit,
          dispatch = _ref18.dispatch;
      var tagName = _ref19.tagName;
      return new Promise( /*#__PURE__*/function () {
        var _ref20 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee8(resolve) {
          var newPage, isCurrent, len, i, index, _newPage, _newPage$name, name, _newPage$params, params, _newPage$query, query, routerObj;

          return _regeneratorRuntime().wrap(function _callee8$(_context8) {
            while (1) {
              switch (_context8.prev = _context8.next) {
                case 0:
                  // 下个新的页面
                  newPage = state.opened[0];
                  isCurrent = state.current === tagName; // 如果关闭的页面就是当前显示的页面

                  if (!isCurrent) {
                    _context8.next = 12;
                    break;
                  }

                  // 去找一个新的页面
                  len = state.opened.length;
                  i = 0;

                case 5:
                  if (!(i < len)) {
                    _context8.next = 12;
                    break;
                  }

                  if (!(state.opened[i].fullPath === tagName)) {
                    _context8.next = 9;
                    break;
                  }

                  // 是否只剩最后一个，是则跳首页
                  if (len > 1) {
                    // 如果是最后一个，则向前一个跳，否则向下一个跳
                    if (i === len - 1) {
                      newPage = state.opened[i - 1];
                    } else {
                      newPage = state.opened[i + 1];
                    }
                  } else {
                    newPage = {};
                  }

                  return _context8.abrupt("break", 12);

                case 9:
                  i++;
                  _context8.next = 5;
                  break;

                case 12:
                  // 找到这个页面在已经打开的数据里是第几个
                  index = state.opened.findIndex(function (page) {
                    return page.fullPath === tagName;
                  });

                  if (index >= 0) {
                    // 如果这个页面是缓存的页面 将其在缓存设置中删除
                    commit('keepAliveRemove', state.opened[index].name); // 更新数据 删除关闭的页面

                    state.opened.splice(index, 1);
                  } // 持久化


                  _context8.next = 16;
                  return dispatch('opened2db');

                case 16:
                  // 最后需要判断是否需要跳到首页
                  if (isCurrent) {
                    _newPage = newPage, _newPage$name = _newPage.name, name = _newPage$name === void 0 ? 'index' : _newPage$name, _newPage$params = _newPage.params, params = _newPage$params === void 0 ? {} : _newPage$params, _newPage$query = _newPage.query, query = _newPage$query === void 0 ? {} : _newPage$query;
                    routerObj = {
                      name: name,
                      params: params,
                      query: query
                    };

                    if (routerObj.name == 'memberCenter') {
                      routerObj.name = 'memberCenterSon';
                    }

                    router.push(routerObj, function () {});
                  } // end


                  resolve();

                case 18:
                case "end":
                  return _context8.stop();
              }
            }
          }, _callee8);
        }));

        return function (_x7) {
          return _ref20.apply(this, arguments);
        };
      }());
    },

    /**
     * @description 关闭当前标签左边的标签
     * @param {Object} param { pageSelect: 当前选中的tagName }
     */
    closeLeft: function closeLeft(_ref21) {
      var state = _ref21.state,
          commit = _ref21.commit,
          dispatch = _ref21.dispatch;

      var _ref22 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
          pageSelect = _ref22.pageSelect;

      return new Promise( /*#__PURE__*/function () {
        var _ref23 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee9(resolve) {
          var pageAim, currentIndex;
          return _regeneratorRuntime().wrap(function _callee9$(_context9) {
            while (1) {
              switch (_context9.prev = _context9.next) {
                case 0:
                  pageAim = pageSelect || state.current;
                  currentIndex = 0;
                  state.opened.forEach(function (page, index) {
                    if (page.fullPath === pageAim) {
                      currentIndex = index;
                    }
                  });

                  if (currentIndex > 0) {
                    // 删除打开的页面 并在缓存设置中删除
                    state.opened.splice(1, currentIndex - 1).forEach(function (_ref24) {
                      var name = _ref24.name;
                      return commit('keepAliveRemove', name);
                    });
                  }

                  state.current = pageAim;

                  if (router.app.$route.fullPath !== pageAim) {
                    router.push(pageAim);
                  } // 持久化


                  _context9.next = 8;
                  return dispatch('opened2db');

                case 8:
                  // end
                  resolve();

                case 9:
                case "end":
                  return _context9.stop();
              }
            }
          }, _callee9);
        }));

        return function (_x8) {
          return _ref23.apply(this, arguments);
        };
      }());
    },

    /**
     * @description 关闭当前标签右边的标签
     * @param {Object} param { pageSelect: 当前选中的tagName }
     */
    closeRight: function closeRight(_ref25) {
      var state = _ref25.state,
          commit = _ref25.commit,
          dispatch = _ref25.dispatch;

      var _ref26 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
          pageSelect = _ref26.pageSelect;

      return new Promise( /*#__PURE__*/function () {
        var _ref27 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee10(resolve) {
          var pageAim, currentIndex;
          return _regeneratorRuntime().wrap(function _callee10$(_context10) {
            while (1) {
              switch (_context10.prev = _context10.next) {
                case 0:
                  pageAim = pageSelect || state.current;
                  currentIndex = 0;
                  state.opened.forEach(function (page, index) {
                    if (page.fullPath === pageAim) {
                      currentIndex = index;
                    }
                  }); // 删除打开的页面 并在缓存设置中删除

                  state.opened.splice(currentIndex + 1).forEach(function (_ref28) {
                    var name = _ref28.name;
                    return commit('keepAliveRemove', name);
                  }); // 设置当前的页面

                  state.current = pageAim;

                  if (router.app.$route.fullPath !== pageAim) {
                    router.push(pageAim);
                  } // 持久化


                  _context10.next = 8;
                  return dispatch('opened2db');

                case 8:
                  // end
                  resolve();

                case 9:
                case "end":
                  return _context10.stop();
              }
            }
          }, _callee10);
        }));

        return function (_x9) {
          return _ref27.apply(this, arguments);
        };
      }());
    },

    /**
     * @description 关闭当前激活之外的 tag
     * @param {Object} param { pageSelect: 当前选中的tagName }
     */
    closeOther: function closeOther(_ref29) {
      var state = _ref29.state,
          commit = _ref29.commit,
          dispatch = _ref29.dispatch;

      var _ref30 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
          pageSelect = _ref30.pageSelect;

      return new Promise( /*#__PURE__*/function () {
        var _ref31 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee11(resolve) {
          var pageAim, currentIndex;
          return _regeneratorRuntime().wrap(function _callee11$(_context11) {
            while (1) {
              switch (_context11.prev = _context11.next) {
                case 0:
                  pageAim = pageSelect || state.current;
                  currentIndex = 0;
                  state.opened.forEach(function (page, index) {
                    if (page.fullPath === pageAim) {
                      currentIndex = index;
                    }
                  }); // 删除打开的页面数据 并更新缓存设置

                  if (currentIndex === 0) {
                    state.opened.splice(1).forEach(function (_ref32) {
                      var name = _ref32.name;
                      return commit('keepAliveRemove', name);
                    });
                  } else {
                    state.opened.splice(currentIndex + 1).forEach(function (_ref33) {
                      var name = _ref33.name;
                      return commit('keepAliveRemove', name);
                    });
                    state.opened.splice(1, currentIndex - 1).forEach(function (_ref34) {
                      var name = _ref34.name;
                      return commit('keepAliveRemove', name);
                    });
                  } // 设置新的页面


                  state.current = pageAim;

                  if (router.app.$route.fullPath !== pageAim) {
                    router.push(pageAim);
                  } // 持久化


                  _context11.next = 8;
                  return dispatch('opened2db');

                case 8:
                  // end
                  resolve();

                case 9:
                case "end":
                  return _context11.stop();
              }
            }
          }, _callee11);
        }));

        return function (_x10) {
          return _ref31.apply(this, arguments);
        };
      }());
    },

    /**
     * @description 关闭所有 tag
     * @param {Object} state vuex state
     */
    closeAll: function closeAll(_ref35) {
      var state = _ref35.state,
          commit = _ref35.commit,
          dispatch = _ref35.dispatch;
      return new Promise( /*#__PURE__*/function () {
        var _ref36 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee12(resolve) {
          return _regeneratorRuntime().wrap(function _callee12$(_context12) {
            while (1) {
              switch (_context12.prev = _context12.next) {
                case 0:
                  // 删除打开的页面 并在缓存设置中删除
                  state.opened.splice(1).forEach(function (_ref37) {
                    var name = _ref37.name;
                    return commit('keepAliveRemove', name);
                  }); // 持久化

                  _context12.next = 3;
                  return dispatch('opened2db');

                case 3:
                  // 关闭所有的标签页后需要判断一次现在是不是在首页
                  if (router.app.$route.name !== 'memberCenterSon' && util.cookies.get('auth-token')) {
                    router.push({
                      name: 'memberCenterSon'
                    }, function () {});
                  } // end


                  resolve();

                case 5:
                case "end":
                  return _context12.stop();
              }
            }
          }, _callee12);
        }));

        return function (_x11) {
          return _ref36.apply(this, arguments);
        };
      }());
    },
    closeAllCopy: function closeAllCopy(_ref38) {
      var state = _ref38.state,
          commit = _ref38.commit,
          dispatch = _ref38.dispatch;
      return new Promise( /*#__PURE__*/function () {
        var _ref39 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee13(resolve) {
          return _regeneratorRuntime().wrap(function _callee13$(_context13) {
            while (1) {
              switch (_context13.prev = _context13.next) {
                case 0:
                  // 删除打开的页面 并在缓存设置中删除
                  state.opened.splice(1).forEach(function (_ref40) {
                    var name = _ref40.name;
                    return commit('keepAliveRemove', name);
                  }); // 持久化

                  _context13.next = 3;
                  return dispatch('opened2db');

                case 3:
                  // end
                  resolve();

                case 4:
                case "end":
                  return _context13.stop();
              }
            }
          }, _callee13);
        }));

        return function (_x12) {
          return _ref39.apply(this, arguments);
        };
      }());
    },

    /**
     * @description 直接更新 opened，用于拖拽调整页签顺序
     * */
    updateOpened: function updateOpened(_ref41, _ref42) {
      var state = _ref41.state,
          commit = _ref41.commit,
          dispatch = _ref41.dispatch;
      var opened = _ref42.opened;
      return new Promise( /*#__PURE__*/function () {
        var _ref43 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee14(resolve) {
          return _regeneratorRuntime().wrap(function _callee14$(_context14) {
            while (1) {
              switch (_context14.prev = _context14.next) {
                case 0:
                  state.opened = opened; // 持久化

                  _context14.next = 3;
                  return dispatch('opened2db');

                case 3:
                  // end
                  resolve();

                case 4:
                case "end":
                  return _context14.stop();
              }
            }
          }, _callee14);
        }));

        return function (_x13) {
          return _ref43.apply(this, arguments);
        };
      }());
    }
  },
  mutations: {
    /**
     * @class loginOutRemove
     * @description 退出登录时，清除面包屑签缓存
     * @param {Object} state vuex state
     */
    loginOutRemove: function loginOutRemove(state) {
      state.opened = [{
        'meta': {
          'title': '我的首页',
          'closable': false
        },
        'name': 'memberCenterSon',
        'path': 'memberCenter',
        'params': {},
        'query': {},
        'fullPath': '/index/memberCenter'
      }];
      state.keepAlive = [];
      state.pool = [];
      state.current = [];
      state.currentTop = [];
    },

    /**
     * @class keepAlive
     * @description 从已经打开的页面记录中更新需要缓存的页面记录
     * @param {Object} state vuex state
     */
    keepAliveRefresh: function keepAliveRefresh(state) {
      state.keepAlive = state.opened.filter(function (item) {
        return isKeepAlive(item);
      }).map(function (e) {
        return e.name;
      });
    },

    /**
     * @description 删除一个页面的缓存设置
     * @param {Object} state vuex state
     * @param {String} name name
     */
    keepAliveRemove: function keepAliveRemove(state, name) {
      var list = _toConsumableArray(state.keepAlive);

      var index = list.findIndex(function (item) {
        return item === name;
      });

      if (index !== -1) {
        list.splice(index, 1);
        state.keepAlive = list;
      }
    },

    /**
     * @description 增加一个页面的缓存设置
     * @param {Object} state vuex state
     * @param {String} name name
     */
    keepAlivePush: function keepAlivePush(state, name) {
      var keep = _toConsumableArray(state.keepAlive);

      keep.push(name);
      state.keepAlive = keep;
    },

    /**
     * @description 清空页面缓存设置
     * @param {Object} state vuex state
     */
    keepAliveClean: function keepAliveClean(state) {
      state.keepAlive = [];
    },

    /**
     * @class current
     * @description 设置当前激活的页面 fullPath
     * @param {Object} state vuex state
     * @param {String} fullPath new fullPath
     */
    currentSet: function currentSet(state, fullPath) {
      state.current = fullPath;
    },

    /**
     * @class pool
     * @description 保存 pool (候选池)
     * @param {Object} state vuex state
     * @param {Array} routes routes
     */
    init: function init(state, routes) {
      var pool = [];

      var push = function push(routes) {
        routes.forEach(function (route) {
          if (route.children) {
            push(route.children);
          } else {
            if (!route.meta || !route.meta.hidden) {
              var meta = route.meta,
                  name = route.name,
                  path = route.path;
              pool.push({
                meta: meta,
                name: name,
                path: path
              });
            }
          }
        });
      };

      push(routes);
      state.pool = pool;
    }
  }
};